import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { Zap } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    axios.post(`${API}/auth/google-session`, { session_id: sessionId })
      .then((res) => {
        setAuth(res.data.session_token, res.data.user);
        window.history.replaceState(null, "", "/feed");
        navigate("/feed", { replace: true });
      })
      .catch(() => navigate("/"));
  }, [navigate, setAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center animate-pulse">
          <Zap className="w-6 h-6 text-primary-foreground" />
        </div>
        <p className="text-muted-foreground">Autenticando...</p>
      </div>
    </div>
  );
}
